import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as settingManagementApi from '@services/api/settingManagementApi'
import moment from 'moment'

export const getLiverVideoPointPerPeriodSetting = createAsyncThunk(
  'LiverVideoPointPerPeriod/getLiverVideoPointPerPeriodSetting',
  async () => {
    const response = settingManagementApi.fetchLiverVideoPointPerPeriodSettings()
    return response
  }
)

export const updateLiverVideoPointPerPeriodSetting = createAsyncThunk(
  'LiverVideoPointPerPeriod/updateLiverVideoPointByPeriodSettings',
  async (data: any) => {
    const response = settingManagementApi.updateLiverVideoPointPerPeriodSettings(data)
    return response
  }
)

const initialState : TSettingManagement.TState = {
  liverVideoPointPerPeriodSettings: {
    data: {
      pointPerPeriods: [],
      liverVideoDefaultRewardPoint: 0
    },
    isLoading: false
  }
}

const settingManagementSlice = createSlice({
  name: 'settingManagementSlice',
  initialState,
  reducers: {
    setLiverPointPerPeriodLoading (state, action) {
      state.liverVideoPointPerPeriodSettings.isLoading = action.payload
    },
    changeLiverPointPerPeriodStartDate (state, action) {
      const { value, index } = action.payload
      const setting = state.liverVideoPointPerPeriodSettings.data.pointPerPeriods[index]
      if (setting) {
        setting.startDate = value
      }
    },
    changeLiverPointPerPeriodEndDate (state, action) {
      const { value, index } = action.payload
      const setting = state.liverVideoPointPerPeriodSettings.data.pointPerPeriods[index]
      if (setting) {
        setting.endDate = value
      }
    },
    changeLiverPointPerPeriodPoint (state, action) {
      const { value, index } = action.payload
      const setting = state.liverVideoPointPerPeriodSettings.data.pointPerPeriods[index]
      if (setting) {
        setting.point = value
      }
    },
    addLiverPointPerPeriodSetting (state) {
      state.liverVideoPointPerPeriodSettings.data.pointPerPeriods.push({ startDate: '', endDate: '', point: 0 })
    },
    removeLiverPointPerPeriodSetting (state, action) {
      state.liverVideoPointPerPeriodSettings.data.pointPerPeriods.splice(action.payload, 1)
    },
    changeliverVideoDefaultRewardPoint (state, action) {
      state.liverVideoPointPerPeriodSettings.data.liverVideoDefaultRewardPoint = action.payload
    }
  },
  extraReducers: builder => {
    builder.addCase(getLiverVideoPointPerPeriodSetting.fulfilled, (state, action) => {
      state.liverVideoPointPerPeriodSettings = action.payload
      state.liverVideoPointPerPeriodSettings.data.pointPerPeriods = state
        .liverVideoPointPerPeriodSettings.data.pointPerPeriods.map(s => {
          s.startDate = moment(s.startDate).format('YYYY-MM-DD')
          s.endDate = moment(s.endDate).format('YYYY-MM-DD')
          return { ...s, startDate: moment(s.startDate).format('YYYY-MM-DD'), endDate: moment(s.endDate).format('YYYY-MM-DD') }
        })
    })
  }
})

export const {
  setLiverPointPerPeriodLoading,
  changeLiverPointPerPeriodStartDate,
  changeLiverPointPerPeriodEndDate,
  addLiverPointPerPeriodSetting,
  removeLiverPointPerPeriodSetting,
  changeLiverPointPerPeriodPoint,
  changeliverVideoDefaultRewardPoint
} = settingManagementSlice.actions

export const settingManagementReducer = settingManagementSlice.reducer

export default settingManagementSlice.reducer
